export const TOKEN_KEY = "@auth:token";
export const USER_KEY = "@auth:user";

// Remoção dirigida em vez de localStorage.clear(): o namespace @ui: guarda
// preferências de interface que não pertencem à sessão e não devem morrer no
// logout nem num 403.
export function clearAuthSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}
